var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "showcase-container" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "slick-carousel",
            {
              ref: "primaryCarousel",
              staticClass: "showcase-carousel",
              attrs: { options: _vm.getPrimaryCarouselOptions() }
            },
            _vm._l(_vm.markets, function(market, index) {
              return _c(
                "div",
                { key: "market-" + index, staticClass: "market" },
                [
                  _c("div", { staticClass: "container" }, [
                    _c(
                      "div",
                      {
                        staticClass: "primary",
                        style:
                          "background-image: url(" +
                          market.primary_image.url +
                          ");"
                      },
                      [
                        _c("h2", {
                          staticClass: "title",
                          domProps: { innerHTML: _vm._s(market.market_name) }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "secondary" }, [
                      _c("div", { staticClass: "row top" }, [
                        _c("div", { staticClass: "full-col" }, [
                          _c("div", { staticClass: "inner" }, [
                            _c("div", {
                              staticClass: "top-title",
                              domProps: {
                                innerHTML: _vm._s(market.feature_1.top_title)
                              }
                            }),
                            _vm._v(" "),
                            _c("h2", {
                              staticClass: "title",
                              domProps: {
                                innerHTML: _vm._s(market.feature_1.title)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "copy",
                              domProps: {
                                innerHTML: _vm._s(market.feature_1.copy)
                              }
                            }),
                            _vm._v(" "),
                            market.feature_1.button
                              ? _c("a", {
                                  staticClass: "btn hover-button bright-blue",
                                  attrs: {
                                    href: market.feature_1.button.url,
                                    target: market.feature_1.button.target
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      market.feature_1.button.title
                                    )
                                  }
                                })
                              : _vm._e()
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("img", {
                            staticClass: "secondary-image",
                            attrs: { src: market.secondary_image["url"] }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col nex-col" }, [
                          _c(
                            "div",
                            {
                              staticClass: "next-block",
                              on: {
                                click: function($event) {
                                  return _vm.moveNext(index)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "top-arrow" }, [
                                _c("i", { staticClass: "fas fa-chevron-right" })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("div", { staticClass: "top-title" }, [
                                  _vm._v("Next")
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "next-market-title",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.nextMarket(index).market_name
                                    )
                                  }
                                })
                              ])
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "secondary-container bg-bright-blue" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "slick-carousel",
              {
                staticClass: "showcase-selection-carousel",
                attrs: { options: _vm.getSecondaryCarouselOptions() }
              },
              _vm._l(_vm.markets, function(market, index) {
                return _c(
                  "div",
                  {
                    key: "market-selector-" + index,
                    staticClass: "item",
                    class: { active: _vm.selectedIndex == index },
                    on: {
                      click: function($event) {
                        return _vm.setSelectedMarket(index)
                      }
                    }
                  },
                  [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(market.market_name) }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "dot" })
                  ]
                )
              }),
              0
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "showcase-container-mobile" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "slick-carousel",
            {
              staticClass: "showcase-carousel-mobile",
              attrs: { options: _vm.getMobileCarouselOptions() }
            },
            _vm._l(_vm.markets, function(market, index) {
              return _c(
                "div",
                { key: "mobile-market-" + index, staticClass: "market" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "inner",
                      style:
                        "background-image: url(" +
                        market.mobile_image.url +
                        ");"
                    },
                    [
                      _c("div", { staticClass: "top-title" }, [
                        _vm._v("Markets")
                      ]),
                      _vm._v(" "),
                      _c("h2", {
                        staticClass: "title",
                        domProps: { innerHTML: _vm._s(market.market_name) }
                      }),
                      _vm._v(" "),
                      _c("a", {
                        staticClass: "btn btn-orange",
                        attrs: {
                          href: market.market_button.url,
                          target: market.market_button.target
                        },
                        domProps: {
                          innerHTML: _vm._s(market.market_button.title)
                        }
                      })
                    ]
                  )
                ]
              )
            }),
            0
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }